import { Injectable } from "@angular/core";
import { LocationViewModel } from "../../shared/models/locations/LocationViewModel.model";

@Injectable()
export class LocationValidationService {
  constructor() {}

  validate(location: LocationViewModel): string[] {
    const errors: string[] = [];

    // Name is required
    if (!location.name || location.name.trim() === "") {
      errors.push("Location name is required");
    }

    // Location ID is required
    if (!location.locId || location.locId.trim() === "") {
      errors.push("Location ID is required");
    }

    // At least one of city or zip is required
    const hasCity = location.city && location.city.trim() !== "";
    const hasZip = location.zipcode && location.zipcode.trim() !== "";
    
    if (!hasCity && !hasZip) {
      errors.push("Either city or zip code is required");
    }

    return errors;
  }
}

